import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class PosService {

  constructor(private api: ApiService) { }

  public updatePosStatus(data: string): Observable<any> {
    var rtn = this.api.post(`/api/v1/store/status`, { "status": data, "delivery_platform": ["UBER_EATS"] }, `pos`)
    return rtn;
  }

  public getItems(): Observable<any> {
    var rtn = this.api.get('/api/v1/items', `pos`)
    return rtn;
  }

  public addItem(data: any): Observable<any> {
    var rtn = this.api.postfileUpload('/api/v1/items', data, `pos`)
    return rtn;
  }

  public editItem(id, data: any, image): Observable<any> {
    var rtn = this.api.postimageUpload('/api/v1/items/' + id, data, `pos`)
    return rtn;
  }

  public getModifires(mainMenuId?: any): Observable<any> {
    var rtn = this.api.get('/api/v1/get-wizard-modifiers?main_menu=' + mainMenuId, `pos`)
    return rtn;
  }

  public getModifiresGroups(): Observable<any> {
    var rtn = this.api.get('/api/v1/modifier-group', `pos`)
    return rtn;
  }


  public getAlegeries(): Observable<any> {
    var rtn = this.api.get('/api/v1/get-wizard-allergies', `pos`)
    return rtn;
  }

  public deleteItem(id): Observable<any> {
    var rtn = this.api.delete(`/api/v1/items/${id}`, `pos`)
    return rtn;
  }

  public filterItems(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/items/filter`, data, `pos`)
    return rtn;
  }

  public filterMappingItems(status: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/filter-mapped-items?status=${status}`, `pos`)
    return rtn;
  }

  public syncPos(): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos/sync`, `pos`)
    return rtn;
  }

  public syncPOS(id: Number, update_modifiers): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos/sync?shop_id=${id}&update_modifiers=${update_modifiers}`, `pos`)
    return rtn;
  }

  public getCategoriesForMernu(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus/${id}/categories`, `pos`)
    return rtn;
  }

  public getCategories(): Observable<any> {
    var rtn = this.api.get(`/api/v1/categories`, `pos`)
    return rtn;
  }

  public getCategoriesForMainMenu(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}/categories-with-items`, `pos`)
    return rtn;
  }

  public getCategory(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/categories/${id}`, `pos`)
    return rtn;
  }

  public searchCategory(searchKey: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/categories?q=${searchKey}`, `pos`)
    return rtn;
  }

  public createCategory(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/categories`, data, `pos`)
    return rtn;
  }

  public editCategory(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/categories/${id}`, data, `pos`)
    return rtn;
  }

  public deleteCategory(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/categories/${id}`, `pos`)
    return rtn;
  }

  public updateCatPriority(data: any): Observable<any> {
    const formData = new FormData();
    for (let i = 0; i < data.length; i++) {
      formData.append('priority[' + i + ']', data[i]);
    }
    var rtn = this.api.postfileUpload(`/api/v1/categories/update-priority`, formData, `pos`)
    return rtn;
  }

  public filterMappingItemsByKeyword(status: any, menuid, keyword): Observable<any> {
    var rtn = this.api.get(`/api/v1/filter-mapped-items?status=${status}&main_menu=${menuid}&query=${keyword}`, `pos`)
    return rtn;
  }

  public getPlatformItems(): Observable<any> {
    var rtn = this.api.get(`/api/v1/platform-items`, `pos`)
    return rtn;
  }

  public mapItem(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/save-platform-item-mapping`, data, `pos`)
    return rtn;
  }

  public getMenus(): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu`, `pos`)
    return rtn;
  }

  public createMenu(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/main-menu`, data, `pos`)
    return rtn;
  }

  public editMenu(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/main-menu/${id}`, data, `pos`)
    return rtn;
  }

  public editMenuWithImage(id: Number, data: any): Observable<any> {
    var rtn = this.api.postimageUpload(`/api/v1/main-menu/${id}`, data, `pos`)
    return rtn;
  }

  public deleteMenu(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/main-menu/${id}`, `pos`)
    return rtn;
  }

  public getMenu(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}`, `pos`)
    return rtn;
  }

  public getItemsByMenuId(id, itemId = null): Observable<any> {
    var rtn = this.api.get(`/api/v1/items?main_menu=` + id + (itemId ? '&item_id=' + itemId : ''), `pos`)
    return rtn;
  }

  public getMenuItems(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus/${id}/items`, `pos`)
    return rtn;
  }

  public saveManu(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/main-menu/${id}/items`, data, `pos`)
    return rtn;
  }

  public getMappingItems(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/get-mapping-menu-list?main_menu=${id}`, `pos`)
    return rtn;
  }

  public getRemainingItems(): Observable<any> {
    var rtn = this.api.get(`/api/v1/get-unmatched-items`, `pos`)
    return rtn;
  }

  public createItemForRemaining(id: any, menu: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/create-item-for-remaining/${id}?main_menu=${menu}`, `pos`)
    return rtn;
  }

  public getAvailabilityOutlets(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}/outlets`, `pos`)
    return rtn;
  }

  public duplicateMenu(id: number, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/main-menu/${id}/clone`, data, `pos`)
    return rtn;
  }

  public getItemsForPreview(id: any, dp: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}/categories?dp=${dp}&active=${1}`, `pos`)
    return rtn;
  }

  public addAvailabilityLocation(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/outlet/availability`, data, `pos`)
    return rtn;
  }

  public updateOutletAvailability(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/outlet/availability`, data, `pos`)
    return rtn;
  }

  public deleteShopFromMenu(id: any, outlet_id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/main-menu/${id}/outlets/${outlet_id}`, `pos`)
    return rtn;
  }

  public getSchedulers(): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/schedule`, `pos`)
    return rtn;
  }

  public createScheduler(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/main-menu/schedule`, data, `pos`)
    return rtn;
  }

  public updateScheduler(id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/main-menu/schedule/${id}`, data, `pos`)
    return rtn;
  }

  public deleteScheduler(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/main-menu/schedule/${id}`, `pos`)
    return rtn;
  }
  public getItemsForShops(storeId: any, q: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/outlet/${storeId}/main-menu?q=${q}`, `pos`)
    return rtn;
  }

  public updateAvailability(id: any, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/items/snooze/${id}`, data, `pos`)
    return rtn;
  }
  public getSubMenusForMenu(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}/menus`, `pos`)
    return rtn;
  }

  public getSubMenus(): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus`, `pos`)
    return rtn;
  }

  public getSubMenusForMainMenu(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus?main_menu_id=${id}`, `pos`)
    return rtn;
  }

  public getSubMenu(id: Number): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus/${id}`, `pos`)
    return rtn;
  }

  public getSubMenuCategories(id: Number, mainMenuId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/menus/${id}/categories?main_menu=${mainMenuId}`, `pos`)
    return rtn;
  }

  public createSubMenu(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/menus`, data, `pos`)
    return rtn;
  }

  public editSubMenu(id: Number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/menus/${id}`, data, `pos`)
    return rtn;
  }

  public deleteSubMenu(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/menus/${id}`, `pos`)
    return rtn;
  }

  public getMainMenuItems(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/${id}/entity-items`, `pos`)
    return rtn;
  }

  public createModifier(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/modifier-group`, data, `pos`)
    return rtn;
  }

  public editModifier(id: any, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/modifier-group/${id}`, data, `pos`)
    return rtn;
  }

  public deletModifier(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/modifier-group/${id}`, `pos`)
    return rtn;
  }

  public searchModifiers(keyword: any, mainMenuId?: any): Observable<any> {
    return this.api.get(`/api/v1/get-wizard-modifiers?main_menu=${mainMenuId}&q=${keyword}`, 'pos')
  }

  public getAutoSettings(): Observable<any> {
    var rtn = this.api.get('/api/v1/auto-accept/status', `pos`)
    return rtn;
  }
  public getPOSTypes(): Observable<any> {
    var rtn = this.api.get('/api/v1/pos/types', `pos`)
    return rtn;
  }

  public getPOSOld(franchise: any, shop: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos?franchise=${franchise}&shop=${shop}`, `pos`)
    return rtn;
  }

  public getPOS(franchise: any, shop: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos/get_pos_pagination?franchise=${franchise}&shop=${shop}`, `pos`)
    return rtn;
  }

  public getAllPOS(franchise: any, shop: any, keyword): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos/get_pos_pagination?franchise=${franchise}&shop=${shop}&q=${keyword}`, `pos`)
    return rtn;
  }

  public getMorePOS(franchise: any, shop: any, nextUrl): Observable<any> {
    var rtn = this.api.get(`/api/v1/pos/get_pos_pagination?page=${nextUrl}&franchise=${franchise}&shop=${shop}`, `pos`)
    return rtn;
  }

  public addPOS(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/pos`, data, `pos`)
    return rtn;
  }

  public updatePOS(id, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/pos/` + id, data, `pos`)
    return rtn;
  }

  public deletePOS(id: Number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/pos/${id}`, `pos`)
    return rtn;
  }

  public updatePriceDetails(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/inventory/product`, data, `pos`)
    return rtn;
  }

  public updateLocation(data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/outlet/update-location`, data, `pos`)
    return rtn;
  }

  public getMenuList(brand_id: any, outlet_id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/main-menu/webshop-brand/${brand_id}/shop/${outlet_id}`, `pos`)
    return rtn;
  }

  public getProductByShopIdAndMenuId(shopId: any, menuId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop/main-menu/${menuId}/items/shop/${shopId}`, `pos`)
    return rtn;
  }

  public getProductByShopIdAndMenuIdToBrand(shopId: any, brandId: any, menuId: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/webshop/main-menu/${menuId}/items/webshop-brand/${brandId}/shop/${shopId}`, `pos`)
    return rtn;
  }

  public getBogoCategories(): Observable<any> {
    var rtn = this.api.get(`/api/v1/categories?bogo=1`, `pos`)
    return rtn;
  }

}
